//#region IMPORT
import React, { useEffect, useState, useRef } from 'react';
import M_TBM_CUSTOM_03 from './M_TBM_CUSTOM_03';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { useSearch1 } from './M_TBM_CUSTOM_03_Query';
import { useBackStack } from '../../../../Hooks/back/useBackStack'; // 규칙 3 적용
//#endregion

function M_TBM_CUSTOM_03F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const activeStep = useSelector((state) => state.common.activeStep);

  const [loading, setLoading] = useState(false);
  const [fullUrl, setFullUrl] = useState();
  const [renderPreview, setRenderPreview] = useState(null);
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pageWidth, setPageWidth] = useState(window.innerWidth * 1);
  const [pageViewHeight, setPageViewHeight] = useState(0);

  const pageNumberRef = useRef(pageNumber);
  useEffect(() => {
    pageNumberRef.current = pageNumber;
  }, [pageNumber]);
  //#endregion

  //#region

  useBackStack({
    type: 'custom',
    enabled: activeStep === 3,
    onBack: () => {
      if (props.modalToggle2) {
        props.setModalToggle2(false);
        return;
      }

      if (pageNumberRef.current > 1) {
        setPageNumber((prev) => prev - 1);
        return;
      }
    },
  });
  //#endregion

  //#region 이벤트
  useEffect(() => {
    // 초기 데이터 조회
    Search1();

    const handleResize = () => {
      setPageWidth(window.innerWidth * 1);
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [pageNumber, loading]);
  //#endregion

  //#region 쿼리
  const { refetch: Search1 } = useSearch1({
    onSuccess: async (rows) => {
      if (!rows || rows.length === 0) return;

      const first = rows[0];
      const path = first?.eduLocation;

      if (!path) {
        setFullUrl(null);
        setRenderPreview(null);
        return;
      }

      const ext = path.split('.').pop()?.toLowerCase();
      let finalPath = path;
      // 문서 파일 확장자 체크 및 PDF 경로 변환
      if (['hwp', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)) {
        finalPath = path.replace(/\.[^/.]+$/, '.pdf');
      }

      const fileUrl = `${Global.file.useUrl}files/${finalPath}`;
      setFullUrl(fileUrl);

      try {
        const res = await fetch(fileUrl);
        const blob = await res.blob();
        const base64 = await blobToBase64(blob);
        setRenderPreview(base64);
      } catch (error) {
        console.error('PDF Fetch Error:', error);
      }
    },
  });
  //#endregion

  //#region 나머지 함수
  const getExtensionFromUrl = (url = '') => {
    const parts = url?.split('.');
    return parts?.length > 1 ? parts.pop().toLowerCase() : '';
  };

  const onDocumentLoadSuccess = ({ numPages: total }) => {
    setNumPages(total);
  };

  const goToPrevPage = () => {
    if (pageNumber > 1) {
      setLoading(true);
      setPageNumber(pageNumber - 1);
    }
  };

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setLoading(true);
      setPageNumber(pageNumber + 1);
    }
  };

  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  //#endregion

  return (
    <M_TBM_CUSTOM_03
      userInfo={userInfo}
      loading={loading}
      setLoading={setLoading}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      pageNumber={pageNumber}
      pageWidth={pageWidth}
      numPages={numPages}
      activeStep={activeStep}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      pageViewHeight={pageViewHeight}
      setPageViewHeight={setPageViewHeight}
      renderPreview={renderPreview}
      goToPrevPage={goToPrevPage}
      goToNextPage={goToNextPage}
      check={props.check}
      setCheck={props.setCheck}
      modalToggle2={props.modalToggle2}
      setModalToggle2={props.setModalToggle2}
      ActiveButton={props.ActiveButton}
      fullUrl={fullUrl}
      getExtensionFromUrl={getExtensionFromUrl}
    />
  );
}

export default M_TBM_CUSTOM_03F;
